import { withTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import React from "react";
import nscStyles from "../nsc/deliveryRangesRow/NscDeliveryRangesRow.module.scss";
import dealerStyles from "../dealer/DealerDeliveryRanges.module.scss";
import NewRangeRow from "../shared/NewRangeRow";
import { TextValidator } from "react-material-ui-form-validator";
import Button from "@material-ui/core/Button";
import MultiToggleWidget from "../../../../shared/toggles/multiToggleWidget/MultiToggleWidget";
import UpperCaseText from "../../../../utils/UpperCaseText";

const MarketDeliveryRangesRow = (props) => {
  function formatRange(range) {
    return range === -1 ? "OVER" : range;
  }

  return (
    <div className={nscStyles.rowBorder}>
      {props.editMode ? (
        <Grid container className="pagePaddingRight pagePaddingLeft">
          <Grid item md={5} className={nscStyles.rowItem}>
            <NewRangeRow {...props} />
          </Grid>
          <Grid item md={3} className={dealerStyles.rowItem}>
            <div>
              <MultiToggleWidget
                settings={{
                  acceptedText: props.t("GeneralEMP.statusYes"),
                  rejectedText: props.t("GeneralEMP.statusNo"),
                }}
                isToggleDisabled={
                  props.currentRow > props.firstDeclined || props.currentRow < 2
                }
                toggleName={"toggle" + props.currentRow.toString()}
                currentStatus={props.dataObjItem.enabled ? "yes" : "no"}
                onSelect={(e) => props.toggleRangeRow(e, props.currentRow)}
              />
            </div>
          </Grid>
          <Grid
            item
            xs={4}
            className={`${nscStyles.rowItem} ${nscStyles.right}`}
          >
            <TextValidator
              className={nscStyles.textBox}
              style={{ marginTop: "10px", marginBottom: "10px" }}
              id={props.currentRow === null ? "" : props.currentRow.toString()}
              name={"rangeValue" + props.currentRow.toString()}
              variant="outlined"
              value={
                props.dataObjItem.value === null ? "" : props.dataObjItem.value
              }
              validators={[
                "required",
                "matchRegexp:^[0-9\\b.]+$",
                "isNumber",
                "isNumericWithTwoDecimalPlaces",
              ]}
              errorMessages={[
                props.t("nscDeliveryBands.required"),
                props.t("nscDeliveryBands.invalid"),
                props.t("nscDeliveryBands.invalid"),
                props.t("nscDeliveryBands.invalid"),
              ]}
              onChange={props.action}
            />
          </Grid>
          <div className={`${nscStyles.rowItem} ${nscStyles.deleteContainer}`}>
            {props.currentNoOfRows > 2 &&
              props.currentRow === props.currentNoOfRows - 1 && (
                <div>
                  <Button
                    id="deleteDeliveryRangeBtn"
                    className={nscStyles.deleteButton}
                    component="button"
                    onClick={props.deleteAction}
                  >
                    {props.t("nscDeliveryBands.delete")}
                  </Button>
                </div>
              )}
          </div>{" "}
        </Grid>
      ) : (
        <Grid container className="pagePaddingLeft pagePaddingRight">
          <Grid item md={5} className={dealerStyles.rowItem}>
            <span> {props.dataObjItem.from}</span>
            {UpperCaseText(props.dataObjItem.to.toString()) === "OVER" ? (
              <span>&nbsp;+</span>
            ) : (
              <span>-{formatRange(props.dataObjItem.to)}</span>
            )}
          </Grid>
          <Grid item md={3} className={dealerStyles.rowItem}>
            <span>
              {props.dataObjItem.enabled
                ? props.t("GeneralEMP.statusYes")
                : props.t("GeneralEMP.statusNo")}
            </span>
          </Grid>
          <Grid
            item
            md={4}
            className={`${dealerStyles.rowItem} ${dealerStyles.right}`}
          >
            <span>
              {props.currency}
              {props.dataObjItem.value}
            </span>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default withTranslation("emp")(MarketDeliveryRangesRow);
